import axiosApiInstance from 'utils/axios-api-instance'

export const fetchBooksTags = () => axiosApiInstance.get(`api/tags`)

export const fetchBooksGenres = () => axiosApiInstance.get(`api/genres`)

export const fetchBookLanguages = () => axiosApiInstance.get(`api/languages`)
